// export const CORE_API_ENDPOINT = "https://api-npi.herokuapp.com"
// 
// // Localhost 
// export const CORE_API_ENDPOINT = "http://localhost:2600"
// export const REDIRECT_O365_URI = "http://localhost:8080/login"
// export const AX_URL = "http://localhost:8080"

// ProdLine UAT Server
// export const QR_READER_ENDPOINT = "https://imsv2test.cigblusolutions.com"
// export const CORE_API_ENDPOINT = "https://prodlinetest.cigblusolutions.com/api"
// export const REDIRECT_O365_URI = "https://prodlinetest.cigblusolutions.com/login"
// export const AX_URL = "https://ciguat.sandbox.operations.dynamics.com"

// ProdLine Prod Server
// export const QR_READER_ENDPOINT = "https://imsv2.cigblusolutions.com"
export const CORE_API_ENDPOINT = "https://productionline.cigblusolutions.com/api"
export const REDIRECT_O365_URI = "https://productionline.cigblusolutions.com/login"
// export const AX_URL = "https://cib.operations.dynamics.com"

export const CLIENT_ID = "0b1bf20d-a148-44d2-8932-027dbaf66a46"
export const ACTIVE_ITEM_TAB = 6   //6
export const ACTIVE_ITEM2_TAB = 2   //6
export const VERSION_NO = "1.3.0"



// WEBPACK FOOTER //
// ./src/lib/api.js